
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11.859 11.859"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 7119","d":"M3.558 9.488a1.186 1.186 0 101.186 1.186 1.189 1.189 0 00-1.186-1.186zM0 0v1.186h1.186l2.135 4.507-.831 1.423a2.107 2.107 0 00-.119.593 1.189 1.189 0 001.187 1.186h7.116V7.709H3.8a.128.128 0 01-.119-.119v-.059l.529-1.008H8.6a1.081 1.081 0 001.006-.593l2.135-3.854a.326.326 0 00.119-.3.56.56 0 00-.593-.593H2.49L1.957 0zm9.488 9.488a1.186 1.186 0 101.186 1.186 1.189 1.189 0 00-1.186-1.186z","fill":"#fff"}})])
          )
        }
      }
    